import React, { useEffect, useState } from "react";
import { ModalPadrao, LabelPadrao, LoadingContainerPadrao, DatePickerPadrao, CheckBoxPadrao } from "../../components/Base";
import { useFetch } from "../../components/Hooks/Conexao";
import Mensagens from "../../components/Mensagens";
import { connect } from "react-redux";
import { fetch } from "../../actions";
import SelectPesq from "../../components/Selects/SelectPesq";
import dayjs from "dayjs";
import TabelaPadrao from "../../components/TabelaPadrao";
import formatarData from "../../Utils/formatarData";
import ContasBaixa from "./ContasBaixa";
import { BtnListar, BtnPadrao, BtnSair } from "../../components/Buttons";
import { Radio } from "antd";
import { Switch } from "@material-ui/core";
import roundCustom from "../../Utils/RoundCustom";
import getCssVariable from "../../Utils/getCssVariable";

const INITIAL_STATE = { dtIni: dayjs().startOf('month'), dtFim: dayjs().endOf('month').startOf('date'), formatoData: "venc", pago: true, aberto: true, validos: true, tipo: "cp", lojaOperacao: true, };

function Contas({ visible, onOk, onCancel, ...props }) {
    const [filtros, setFiltros] = useState(INITIAL_STATE);
    const [dados, listar, isLoading] = useFetch(() => props.fetch().post("contas/getlist", filtros));
    const [marcados, setMarcados] = useState([]);
    const [titulos, setTitulos] = useState([]);
    const [loadingJuros, setLoadingJuros] = useState(false);

    const isPagar = filtros.tipo == "cp";

    const baixar = () => {
        const aux = [];
        for (var i = 0; i < marcados.length; i++) {
            const titulo = dados.find(x => x.id === marcados[i]);

            if (titulo.isRenegociacao) { Mensagens.showWarning("Selecionados títulos já renegociados!"); break; }
            else if (titulo.pag) { Mensagens.showWarning("Selecionados títulos pagos!"); break; }
            else
                aux.push({ ...titulo, valorInicial: titulo.valor, juros: 0, desconto: 0, tipo: filtros.tipo });
        }

        if (aux.map(x => x.empresaCodigo).filter((v, i, a) => a.indexOf(v) === i).length > 1)
            return Mensagens.showWarning("Selecionados títulos de múltiplas empresas!");
        else if (aux.map(x => x.pessoaCodigo).filter((v, i, a) => a.indexOf(v) === i).length > 1)
            return Mensagens.showWarning("Selecionados títulos de múltiplos " + (isPagar ? "fornecedores" : "clientes" + "!"));

        if (aux.length != marcados.length)
            return;

        setLoadingJuros(true);

        props.fetch().post("contas/calcularjuros", aux.map(x => x.id)).then(ret => {
            const data = ret.data;
            if (!!data)
                data.forEach(x => aux[aux.findIndex(s => s.id == x.id)].juros = x.juros);

            setTitulos(aux);
            setLoadingJuros(false);
        }).catch(err => { console.log(err); setTitulos(aux); setLoadingJuros(false); });
    };

    useEffect(() => {
        // if (visible)
        //     listar();

        setFiltros(visible ? { ...filtros, pessoa: undefined } : INITIAL_STATE);
        setMarcados([]);
    }, [visible, filtros.tipo]);

    const columns = [
        {
            Header: "",
            accessor: "sd",
            Cell: props => {
                const x = props.row.original;
                const hoje = dayjs().startOf('day');
                const venc = dayjs(x.venc);

                let cor = '#bbb';
                if (x.isExcluido) cor = 'black';
                else if (x.isRenegociacao) cor = 'brown';
                else if (x.pag) cor = getCssVariable("--verde-padrao");
                else if (venc.isBefore(hoje)) cor = getCssVariable("--vermelho-padrao");
                else if (venc.isSame(hoje)) cor = getCssVariable("--amarelo-padrao");

                return <IconCor cor={cor} />;
            },
            Footer: () => marcados.length ? marcados.length : dados?.length
        },
        {
            Header: "Nome",
            accessor: "pessoa",
        },
        {
            Header: "Empresa",
            accessor: "empresa",
        },
        {
            Header: "Emissão - Vencimento",
            accessor: "emi",
            Cell: props => <span> {formatarData(props.row.original.emi).DATA} - {formatarData(props.row.original.venc).DATA}</span>,
            tipo: "center",
        },
        {
            Header: "Número",
            accessor: "numero",
        },
        {
            Header: "Competência",
            accessor: "comp",
            Cell: props => <span>{formatarData(props.row.original.comp).MESANO}</span>,
            tipo: "center"
        },
        {
            Header: "Valor",
            accessor: "valor",
            tipo: "rs",
        },
        {
            Header: "Baixa",
            accessor: "pag",
            Cell: props => <span>{props.row.original.pag && formatarData(props.row.original.pag).DATA}</span>,
            tipo: "center",
        },
        {
            Header: "Plano de contas",
            accessor: "planoConta",
        }
    ];

    return <ModalPadrao
        visible={visible}
        onCancel={onCancel}
        title="Baixa de títulos"
        width={1200}
        footer={
            <>
                <BtnPadrao disabled={!marcados.length} onClick={baixar}>Baixar</BtnPadrao>
                <BtnSair onClick={onCancel} />
            </>}>
        <LoadingContainerPadrao loading={isLoading || loadingJuros}>
            <div style={{ minHeight: "50vh" }}>
                <div style={{ display: "flex", alignItems: "flex-end" }}>
                    <div style={{ width: 300 }}>
                        <SelectPesq noMargin placeholder="Pesquisar" maxTagTextLength={25} title={isPagar ? "Fornecedor" : "Cliente"} modelo={isPagar ? "fornecedor" : "cliente"} value={filtros.pessoa} onChange={v => setFiltros({ ...filtros, pessoa: v })} />
                    </div>
                    <div style={{ margin: "0 10px" }}>
                        <LabelPadrao noMargin>Início</LabelPadrao>
                        <DatePickerPadrao value={filtros.dtIni} onChange={dt => setFiltros({ ...filtros, dtIni: dt })} />
                    </div>
                    <div>
                        <LabelPadrao noMargin>Fim</LabelPadrao>
                        <DatePickerPadrao value={filtros.dtFim} onChange={dt => setFiltros({ ...filtros, dtFim: dt })} />
                    </div>
                    <div style={{ margin: "0 10px" }}>
                        <LabelPadrao noMargin style={{ marginBottom: 10 }} >Título</LabelPadrao>
                        <CheckBoxPadrao checked={filtros.pago} onChange={() => setFiltros({ ...filtros, pago: !filtros.pago })}>Recebido</CheckBoxPadrao>
                        <CheckBoxPadrao checked={filtros.aberto} onChange={() => setFiltros({ ...filtros, aberto: !filtros.aberto })}>Em Aberto</CheckBoxPadrao>
                    </div>
                    <div>
                        <LabelPadrao noMargin>Empresa operação</LabelPadrao>
                        <Switch checked={filtros.lojaOperacao} onChange={() => setFiltros({ ...filtros, lojaOperacao: !filtros.lojaOperacao })} color="primary" />
                    </div>
                    <BtnListar onClick={listar} />
                </div>
                <div style={{ display: "flex", justifyContent: "center", marginTop: 25 }}>
                    <p><IconCor cor={getCssVariable("--vermelho-padrao")} />Vencido</p>
                    <p style={{ margin: "0 10px" }}><IconCor cor={getCssVariable("--amarelo-padrao")} /> A {isPagar ? "pagar" : "receber"} hoje</p>
                    <p><IconCor cor="#bbb" />A {isPagar ? "pagar" : "receber"} este mês</p>
                    <p style={{ marginLeft: 10 }}><IconCor cor={getCssVariable("--verde-padrao")} /> {isPagar ? "Pago" : "Recebido"} este mês</p>
                </div>
                <Radio.Group style={{ marginBottom: 10 }} onChange={v => setFiltros({ ...filtros, tipo: v.target.value })} value={filtros.tipo}>
                    <Radio value="cp">Pagar</Radio>
                    <Radio value="cr">Receber</Radio>
                </Radio.Group>
                <div className="tabela-wrapper-zero">
                    <TabelaPadrao checkOnlyOne columns={columns} data={dados} marcados={marcados} setMarcados={setMarcados} />
                </div>
            </div>
        </LoadingContainerPadrao>

        <ContasBaixa visible={titulos.length} titulos={titulos} setTitulos={setTitulos} onOk={() => { listar(); setMarcados([]); setTitulos([]); Mensagens.showSucesso("Baixa efetuada com sucesso!"); }} onCancel={() => setTitulos([])} tipo={filtros.tipo} />
    </ModalPadrao>;
}

export default connect(null, { fetch })(Contas);

export function IconCor({ cor }) {
    return <span style={{ height: '22px', width: 3, margin: "0 5px", backgroundColor: cor, display: 'inline-block' }}>&nbsp;</span>;
}